import checkoutComponent from './checkout.component';
import printCheckoutModule from './print';


let checkoutModule = angular.module('checkout', [
  printCheckoutModule
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  // $urlRouterProvider.otherwise('/checkout');

  $stateProvider
    .state('checkout', {
      url: '/checkout',
      component: 'checkout',
      data: {
        requireLogin: true,
        requireACL: 'check_out.all'
      },
      parent:'app',
    });
})

.component('checkout', checkoutComponent)

.name;

export default checkoutModule;


// WEBPACK FOOTER //
// ./client/app/components/checkout/index.js